import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { reaction } from "mobx";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { OiqiaQIcon, KeyIcon, AssistanceIcon, PowerIcon, OiqiaQWhiteIcon, GearIcon } from "../components/Icons";
import { useTheme } from "react-native-paper";
import AccessTabScreen from "./AccessTabScreen";
import HomeStackScreen from "./HomeStackScreen";
import ChatStackScreen from "./ChatStackScreen";
import { mobAlert } from "../mobx/MobAlert";
import i18n from "../i18n";
import { mobUser } from "../mobx/MobUser";
import HomePageButton from "../components/HomePageButton";
import { Dimensions, Platform, View } from "react-native";
import SettingsTabScreen from "./SettingsTabScreen";
import { mobNotif } from "../mobx/MobNotifs";
import { useNavigation } from '@react-navigation/native';

import { useSafeAreaInsets } from "react-native-safe-area-context";


const Tab = createBottomTabNavigator();

const setLogoutModal = () => {
  mobAlert.setAlert(
    i18n.t("pages.logout.modalTitle"),
    null,
    i18n.t("pages.logout.disconnect"),
    () => {
      mobUser.LogOut();
      mobAlert.closeAlert();
    },
    i18n.t("generic.cancel"),
    mobAlert.closeAlert
  );
};

const HomePageButtonComponent = () => {
  const iconSize = Dimensions.get("screen").height * 0.087;
  return <HomePageButton component={{ icon: <PowerIcon height={iconSize} width={iconSize} />, title: i18n.t("home.disconnect"), onPress: setLogoutModal }} />
};

const LoggedInTabNavigator = observer(() => {
  const theme = useTheme();
  const navigation = useNavigation();

  useEffect(() => {
    const disposer = reaction(
      () => mobUser.Language,
      (Language) => {
        //i18n.changeLanguage(Language);
        // Forcer une mise à jour du composant
        forceUpdate();
      }
    );

    return () => disposer();
  }, []);

  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const insets = useSafeAreaInsets();

  return (

    <Tab.Navigator
      screenOptions={{
        headerTitleAlign: "center",
        tabBarShowLabel: true,
        tabBarHideOnKeyboard: true,
        tabBarActiveTintColor: theme.colors.background,
        tabBarInactiveTintColor: theme.colors.primary,
        tabBarActiveBackgroundColor: theme.colors.primary,
        tabBarStyle: {
          backgroundColor: theme.colors.secondary,
          position: Platform.OS === 'ios' ? 'absolute' : 'relative',
          bottom: 0,
          left: 0,
          right: 0,
          height: 60,
          paddingBottom: 0,
          borderTopWidth: 0,
          elevation: 0, // Android shadow fix
          shadowOpacity: 0, // iOS shadow fix
        }

      }}
      initialRouteName="HomeStack"
    >
      <Tab.Screen name="HomeStack" component={HomeStackScreen}
        options={{
          headerShown: false,
          tabBarLabel: () => null,
          tabBarIcon: ({ focused, color, size }) => (focused ?
            <OiqiaQWhiteIcon color={color} height={40} width={40} /> :
            <OiqiaQIcon color={color} height={40} width={40} />
          )
        }}
      />
      <Tab.Screen name="AccessStack" component={AccessTabScreen}
        options={{
          lazy: false,
          tabBarLabel: i18n.t("tabBar.access"),
          headerShown: false,
          tabBarIcon: ({ focused, color, size }) => <KeyIcon color={focused ? theme.colors.background : color} height={50} width={50} />
        }}
      />
      <Tab.Screen
        name="ChatTab"
        component={ChatStackScreen}
        options={{
          tabBarLabel: i18n.t("tabBar.chat"),
          headerShown: false,
          tabBarIcon: ({ focused, color }) => (
            <AssistanceIcon color={focused ? theme.colors.background : color} height={50} width={50} />
          ),
          tabBarBadge: mobNotif.badge > 0 ? mobNotif.badge : undefined,
        }}
      />
      <Tab.Screen name="SettingsStack" component={SettingsTabScreen}
        options={{
          tabBarLabel: i18n.t("tabBar.settings"),
          headerShown: false,
          tabBarIcon: ({ focused, color, size }) => <GearIcon color={focused ? theme.colors.background : color} height={50} width={50} />
        }}
      />
    </Tab.Navigator>
  );
});

export default LoggedInTabNavigator;
